import { render, staticRenderFns } from "./upload-drawer.vue?vue&type=template&id=cdfa6418&scoped=true"
import script from "./upload-drawer.vue?vue&type=script&lang=js"
export * from "./upload-drawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdfa6418",
  null
  
)

export default component.exports